import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { notification } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Service } from '@/infra/services/bera';

export interface SetConsolidateBeraSummaryParams {
	id: string;
	consolidated: boolean;
	locale: string;
	organization_id: string;
	company_id: string;
}

export const useSetConsolidateBeraSummary = () => {
	return useMutation<void, AxiosError<Response>, SetConsolidateBeraSummaryParams>(
		(params: SetConsolidateBeraSummaryParams) => Service.consolidate(params),
		{
			onError: (err: any) => {
				const typeError = err.response.data.details[0]?.split('" ') ?? err;
				notification.error({
					message: I18n.get('Ops... something happened!'),
					description: I18n.get(typeError[1])
				});
			}
		}
	);
};
